import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 3rem;
  background: ${(p) => p.theme.colors.blueDarker};
  color: ${(p) => p.theme.colors.white};
  text-align: center;

  h3 {
    margin: 0 0 1.5rem;
  }

  p {
    max-width: 50rem;
    margin: 0 0 2rem;
    font-size: 1.5rem;
    line-height: 2.2rem;
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 50rem;
`

export const OpenMpos = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5rem;
  border-radius: 0.5rem;
  background: ${(p) => p.theme.colors.turquoiseDark};
  color: ${(p) => p.theme.colors.white};
  font-size: 1.5rem;
  font-weight: 500;
  text-decoration: none;
`

export const Back = styled.button`
  margin: 1rem auto;
  padding: 0;
  border: none;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.white};
  background: none;
  color: ${(p) => p.theme.colors.white};
  font-size: 1.5rem;
  cursor: pointer;
`
